<div class="tab-bar">
  <a (click)="setTab(tab)" class="tab" *ngFor="let tab of model.tabs" [kitText]="tab.text" [ngClass]="{ 'active': model.currentTab === tab }"></a>
</div>

<div class="tab-content" [kitContainer]="model.currentTab?.content">

</div>
